import { AfterViewInit, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { SectionComponent } from 'app/views/presentations/layouts/layouts/section.component';

export abstract class LayoutComponent implements AfterViewInit {
    // Emits the previously selected section, and the new selected section
    private _sectionClicked: EventEmitter<[number, number]> = new EventEmitter();
    @Output() public get sectionClicked() { return this._sectionClicked; }

    private _activeSection: number;
    @Output() public get activeSection() { return this._activeSection; }

    private _sectionsTypes: string[];
    @Input() public set sectionsTypes(value) {
        this._sectionsTypes = value;
        this.refreshSections();
    }

    @ViewChildren(SectionComponent) private sections: QueryList<SectionComponent>;

    private _invalidSections: Set<number> = new Set<number>();
    @Input() public set invalidSections(value) {
        this._invalidSections = value;
        this.refreshSections();
    }

    public ngAfterViewInit(): void {
        setTimeout(() => this.refreshSections(), 0);
    }

    public emitSectionClicked(id: number) {
        if (this.activeSection === id) { return; }
        this.sectionClicked.emit([this._activeSection, id]);
        this._activeSection = id;
        this.refreshSections();
    }

    public getSectionType(id: number) {
        if (!this._sectionsTypes) { return undefined; }
        if (id < 0 || id >= this._sectionsTypes.length) { return undefined; }

        return this._sectionsTypes[id];
    }

    public isSectionValid(id: number) {
        return !this._invalidSections || !this._invalidSections.has(id);
    }

    private refreshSections() {
        if (!this.sections) { return; }
        for (const section of this.sections.toArray()) {
            const id = section.id;
            section.type = this.getSectionType(id);
            section.isValid = this.isSectionValid(id);
            section.isActive = this.activeSection === id;
            section.click.subscribe(() => this.emitSectionClicked(id));
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layout.component.ts